/**
 * Formatiert die Arbeitspaket-Nummer mit dem Kuerzel „AP" davor (z. B. "20" → "AP 20").
 * Traegt die Nummer das Kuerzel bereits (z. B. "AP-1", "ap 3"), bleibt sie unveraendert,
 * damit kein doppeltes "AP AP-1" entsteht.
 */
export function apLabel(nr: string | null | undefined): string {
  const n = (nr ?? '').trim();
  if (n.length === 0) return 'AP';
  if (/^ap(\d|[\s\-_]|$)/i.test(n)) return n;
  return `AP ${n}`;
}
